import { render, staticRenderFns } from "./bill-back.vue?vue&type=template&id=3793515e&scoped=true&"
import script from "./bill-back.vue?vue&type=script&lang=js&"
export * from "./bill-back.vue?vue&type=script&lang=js&"
import style0 from "./bill-back.vue?vue&type=style&index=0&id=3793515e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3793515e",
  null
  
)

export default component.exports